import React, { useState, useEffect } from "react";
import Footer from "../common/Footer/Footer";
import Batches from "../Batch/Batches";
import TopNavBar from "../common/Header/TopNavBar";
import BannerSlides from "../Sections/BannerSlides";
import Projects from "../Sections/Projects";

const HomePage = () => {
  useEffect(() => {
    const batches = getBatches(6);
    //Runs only on the first render
  }, []);

  function getBatches(batches) {
    console.log(batches);
  }

  return (
    <div className="bgbg">
      <TopNavBar />
      <BannerSlides />
      <Batches />
      <Projects />
      <Footer />
    </div>
  );
};

export default HomePage;
